import Button from '../button/Button';
import React from 'react';
import styles from '../../styles/Share.module.scss';
import Snackbar from '@mui/material/Snackbar';
import { useState } from 'react';
import { styled } from '@mui/system';

const Alert = styled((props) => <Snackbar {...props} />)(() => ({
  '.MuiPaper-root': {
    backgroundColor: '#e9eef5',
    borderRadius: '9px',
    color: '#1d76bb',
    boxShadow:
      '9px 9px 16px rgba(0, 0, 0, 0.16), 0px 2px 8px rgba(0, 0, 0, 0.16)',
  },
}));

const Share = ({ text = 'Spodobał Ci się ten artykuł?', type }) => {
  const [showAlert, setShowAlert] = useState(false);
  const link =
    typeof window !== 'undefined' && window.location.href
      ? window.location.href
      : '';

  const copyLink = async () => {
    await navigator.clipboard.writeText(link);
    setShowAlert(true);
  };

  const action = (
    <img
      src={'/close.svg'}
      onClick={() => setShowAlert(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  return (
    <div
      className={
        type === 'secondary' ? styles.secondaryWrapper : styles.primaryWrapper
      }
    >
      <script
        async
        defer
        crossOrigin='anonymous'
        src='https://connect.facebook.net/pl_PL/sdk.js#xfbml=1&version=v13.0'
        nonce='7NG4wCgg'
      ></script>
      <script
        async
        src='https://platform.twitter.com/widgets.js'
        charSet='utf-8'
      />
      <p>
        {text} <strong>UDOSTĘPNIJ</strong>
      </p>
      <div className={styles.buttonsContainer}>
        <div data-href={link} data-layout='button' data-size='small'>
          <a
            target='_blank'
            href={`https://www.facebook.com/sharer/sharer.php?u=${link}&amp;src=sdkpreparse`}
          >
            <Button
              variant='outlined'
              color='white'
              value={<img src='/fb.svg' />}
              className={styles.shareButton}
              disableTouchRipple={true}
            />
          </a>
        </div>
        <div>
          <a
            href={`https://twitter.com/intent/tweet?text=${link.toString()}`}
            data-show-count='false'
            target='_blank'
          >
            <Button
              variant='outlined'
              color='white'
              value={<img src='/twitter.svg' />}
              className={styles.shareButton}
              disableTouchRipple={true}
            />
          </a>
        </div>
        <Button
          variant='outlined'
          color='white'
          onClick={copyLink}
          value={<img src='/url.svg' />}
          className={styles.shareButton}
          disableTouchRipple={true}
        />
      </div>
      {showAlert && (
        <Alert
          open={showAlert}
          autoHideDuration={3000}
          onClose={() => setShowAlert(false)}
          message={'Skopiowano link'}
          action={action}
        />
      )}
    </div>
  );
};

export default Share;
